import useHandleize from '@hooks/useHandleize'
import { useState } from 'react'

import styles from './Chapters.module.scss'

export default function Chapters({ data }) {
  const [isOpen, setIsOpen] = useState(false)

  const handleChapters = () => [setIsOpen(!isOpen)]

  const content = data.articleContent
  const colour = data.colour

  return (
    <div className={styles.wrapper}>
      <div id="chapter-list-container" className={styles.container}>
        <div
          id="chapter-list"
          onClick={handleChapters}
          style={{
            backgroundColor: colour.vibrant.background,
          }}
          className={`${styles.chapterList} ${
            isOpen ? styles.open : styles.closed
          }`}
        >
          <p>
            {isOpen ? (
              <strong>Oooh, enjoy? 👍</strong>
            ) : (
              <>
                <span className="hidden md:inline-block">
                  Don't want to read the whole article? 😏
                </span>
                <strong>Click here for chapters</strong>
              </>
            )}
          </p>

          <ul>
            {content.map((c, i) => {
              if (c._type == 'chapterMarker') {
                return (
                  <li key={i}>
                    <a
                      className={`${styles.chapterItem} ${
                        isOpen ? styles.open : styles.closed
                      }`}
                      href={`#${useHandleize(c.title)}`}
                    >
                      {c.title}
                    </a>
                  </li>
                )
              } else if (
                (c._type == 'block' && c.style == 'h2') ||
                (c.style == 'h3' && !c.children[0].text.includes('NO'))
              ) {
                return (
                  <li key={i}>
                    <a
                      className={`${styles.chapterItem} ${
                        isOpen ? styles.open : styles.closed
                      }`}
                      href={`#${useHandleize(c.children[1] ? c.children[0].text + c.children[1].text : c.children[0].text)}`}
                    >
                      {c.children[1] ? c.children[0].text + c.children[1].text : c.children[0].text} 
                    </a>
                  </li>
                )
              }
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
